
import { mapGetters } from 'vuex'
import PzGoodsInfo from '../pz-goods-info'
import BargainSellerItem from './dialog.vue'
import { orderStatusBySeller } from '@/enum/localEnum'

const BargainSetting = () => import('@/components/Bargain/seller/bargainSetting')

export default {
	props: {
		info: {
			type: Object,
			require: true
		}
	},
	components: {
		PzGoodsInfo,
		BargainSellerItem
	},
	computed: {
		...mapGetters({
			userinfo: 'user/userinfo',
			severTime: 'severTime'
		}),
		/**
		 * 商品置灰
		 * 已下架、已出售
		 */
		goodsDisabled() {
			return ![orderStatusBySeller.ON_STAND, orderStatusBySeller.TRADING].includes(this.info.goodsStatus)
		},
		goodsStatusText() {
			if ([orderStatusBySeller.BEAN_SOLD].includes(this.info.goodsStatus)) {
				return '商品已出售'
			} else {
				return '商品已下架'
			}
		}
	},
	data() {
		return {}
	},
	mounted() {},
	methods: {
		/**
		 * 跳转砍价详情页面
		 * @param {*} e
		 */
		gotoDetail() {
			this.$store.commit('bargain/SET_BARGAIN_GOODS_INFO', this.info)
			this.$router.push({ path: '/account/bargainSeller/detail', query: { goodsNo: this.info.goodsNo } })
		},
		// 报价设置
		onSetBargain() {
			const model = this.$pzDialog(
				{
					title: '报价设置',
					width: '450px',
					top: '15vh',
					cancelButtonText: '取消',
					confirmButtonText: '保存',
					showFooter: false,
					showClose: true,
					component: BargainSetting,
					customClass: 'bargain-setting-dialog',
					componentData: {
						gameId: this.info.gameId,
						goodsCatalogueId: this.info.goodsCatalogueId,
						goodsNo: this.info.goodsNo,
						goodsPrice: this.info.goodsPrice,
						autoRefuse: this.info.autoRefuse,
						autoRefusePrice: this.info.autoRefusePrice,
						autoData: {
							autoAgree: this.info.autoAgree,
							autoAgreePrice: this.info.autoAgreePrice
						},
						limitPrice: this.info.limitPrice
					},
					onConfirm: (isRemove = true) => {
						isRemove && model.remove()
						this.$emit('listRefresh')
					},
					onCancel: () => {
						model.remove()
					}
				},
				this
			)
		}
	}
}
